const dataRenderComponentTypesMap = {
  box_list: 'box_list',
  custom_component: 'custom_component',
  editable_component: 'editable_component',
  form: 'form',
  jujo_grid: 'jujo_grid',
}

export default dataRenderComponentTypesMap
